import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import CATALOG from "@/lib/catalog.json";

const Ctx = createContext(null);

export function toggleKey(list, key) {
  if (list.includes(key)) return list.filter((k) => k !== key);
  let next = [...list, key];
  if (key === "P02") next = next.filter((k) => !k.startsWith("I"));
  if (key.startsWith("I")) next = next.filter((k) => k !== "P02");
  if (key === "P01") next = next.filter((k) => !k.startsWith("R"));
  if (key.startsWith("R")) next = next.filter((k) => k !== "P01");
  return next;
}

const readSel = () => {
  try { return JSON.parse(localStorage.getItem("nillo_sel") || "[]"); } catch { return []; }
};

export function AppProvider({ children }) {
  const [config, setConfig] = useState(CATALOG);
  const [sel, setSel] = useState(readSel);

  useEffect(() => { localStorage.setItem("nillo_sel", JSON.stringify(sel)); }, [sel]);

  const loadConfig = useCallback(() =>
    api.get("/public/config").then((r) => { if (r.data?.items?.length) setConfig(r.data); }).catch(() => {}), []);
  useEffect(() => { loadConfig(); }, [loadConfig]);

  const itemsByKey = useMemo(() => Object.fromEntries((config?.items || []).map((i) => [i.key, i])), [config]);

  const value = {
    config, loadConfig, itemsByKey, sel,
    toggle: (k) => setSel((s) => toggleKey(s, k)),
    addMany: (keys) => setSel((s) => keys.reduce((acc, k) => (acc.includes(k) ? acc : toggleKey(acc, k)), s)),
    clearSel: () => setSel([]),
  };
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useApp = () => useContext(Ctx);
